import { lazy } from 'react';

export const PartnerZodiacPageLazy = lazy(() => import('./partner-zodiac'));
